import React, { Component } from "react";
import { Card, Col, Row, Form, Button, Table } from "react-bootstrap-v5";
import { toast } from "react-toastify";
import ReactToPrint from "react-to-print";
import moment from "moment";
import { reportService } from "../../Services/reportService";
import {Spinner} from "react-bootstrap-v5";
const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;

class Shipment extends Component {
  state = {
    reportObj: [],
    startDate: "",
    endDate: "",
    shipment_mode: "",
    loader:false
  };

  componentDidMount() {
    this.componentRef = React.createRef();
    this.getPerformanceReportData();
  }

  getPerformanceReportData = (params = {item : 432}) => {
    this.setState({loader:true})
    reportService.getPerformanceReort(params).then((result) => {
      if (result.status === true) {
        this.setState({ reportObj: result.data,loader:false });
      } else {
        toast.info("Something went wrong");
      }
    this.setState({loader:false})
    });
  };

  exportToExcel = () => {
    let params = {
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      shipment_mode: this.state.shipment_mode,
    };
    reportService.exportPerformanceReort(params).then((result) => {
      if (result.status === true) {
        window.location.href = REACT_APP_API_BASEURL + "/" + result.data;
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  // handleModeChange = (mode) => {
  //     this.setState({shipment_mode: mode})
  //     let search = { startDate: this.state.startDate, endDate: this.state.endDate ,hipments_mode: mode}
  //     this.getPerformanceRepor`  tData(search)
  // }

  //////By neha
  handleModeChange = (mode) => {
    this.setState({ shipment_mode: mode }, () => {
      let search = {
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        shipment_mode: mode,
      };
      console.log("modechange",search);
      this.getPerformanceReportData(search);
    });
  };

  // handleDateChange = (e) => {
  //     const { name, value } = e.target

  //     let setdate = name === 'start_date' ? 'startDate' : 'endDate'
  //     this.setState({[setdate] : new Date(value).getTime()}, () => {
  //         if(this.state.startDate !== '' && this.state.endDate !== ""){
  //             let search = {startDate: this.state.startDate, endDate: this.state.endDate,shipment_mode: this.state.shipment_mode}
  //             this.getPerformanceReportData(search)
  //         }
  //     })
  // }

  //date selection function //neha
  handleDateChange = (e) => {
    const { name, value } = e.target;
    let setdate = name === "start_date" ? "startDate" : "endDate";

    const selectedDate = new Date(value).getTime();
    this.setState({ [setdate]: selectedDate }, () => {
      const { startDate, endDate } = this.state;

      if (startDate !== "" && endDate !== "") {
        if (startDate > endDate) {
          this.setState({ startDate: "", endDate: "" });
          toast.info("Start date cannot be greater than end date.");
        } else {
          let search = {
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            shipment_mode: this.state.shipment_mode,
          };
          console.log("date",search)
          this.getPerformanceReportData(search);
        }
      }
    });
  };
  findMode = (textMode) => {
    return (
      (textMode?.includes("AIR") && "AIR") ||
      (textMode?.includes("COURIER") && "COURIER") ||
      (textMode?.includes("SEA") && "SEA") ||
      (textMode?.includes("LAND") && "LAND") ||
      (textMode?.includes("LOCAL") && "LOCAL") ||
      "NA"
    );
  };

  render() {
    const { reportObj } = this.state;
    let revTotal = 0,
      costTotal = 0,
      profitTotal = 0;

    return (
      <Card>
        <div className="card-header bg-light">
          <h4>Shipment</h4>
        </div>
        <Card.Body>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Label>Mode</Form.Label>
              <Form.Select
                aria-label="Default select example"
                name="type"
                onChange={(e) => this.handleModeChange(e.target.value)}
              >
                <option value="">Select All</option>
                <option value="AIR">AIR</option>
                <option value="COURIER">COURIER</option>
                <option value="SEA">SEA</option>
                <option value="LAND">LAND</option>
                <option value="LOCAL">LOCAL</option>
              </Form.Select>
            </Col>
            <Col md={3}>
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                name="start_date"
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => this.handleDateChange(e)}
              />
            </Col>
            <Col md={3}>
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                name="end_date"
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => this.handleDateChange(e)}
              />
            </Col>
            <Col md={3} className="d-flex justify-content-end mt-3">
              <Button
                className="me-2 ps-4 pe-4"
                variant="success"
                onClick={() => this.exportToExcel()}
              >
                Excel
              </Button>

              <ReactToPrint
                trigger={() => {
                  return <Button variant="secondary" className="ps-4 pe-4">Print</Button>;
                }}
                content={() => this.componentRef}
                bodyClass={"printElement m-5"}
              />
            </Col>
          </Row>

          <Row className="printElement" ref={(el) => (this.componentRef = el)}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Mode</th>
                  <th>Job Number</th>
                  <th>Customer Name</th>
                  <th>Date</th>
                  <th>Origin</th>
                  <th>Destination</th>
                  <th>Revenue</th>
                  <th>Cost</th>
                  <th>Profit</th>
                  <th>Profit in %</th>
                </tr>
              </thead>
              {this.state.loader &&
                    <tbody>
                        <tr>
                            <td colSpan={20} className='text-center'>
                        <Spinner animation="border" />
                            </td>
                        </tr>
                    </tbody> 
                  ||
              <tbody>
                {
                reportObj.length &&
                  reportObj.map((item, index) => {
                    let mode = this.findMode(
                      item?.shipment_details?.shipment_mode
                    );
                   
                    let rev =
                      item.invoices && item.invoices.invoice_gross_amount
                        ? item.invoices.invoice_gross_amount
                        : 0;
                    let cost =
                      item.costs && item.costs.cost_gross_amount
                        ? item.costs.cost_gross_amount
                        : 0;
                    let profit = rev - cost; // Get Profit
                    let profitPer =
                      profit !== 0 && cost !== 0 ? (profit / cost) * 100 : 0;
                    revTotal = rev + revTotal;
                    costTotal = cost + costTotal;
                    profitTotal = profit + profitTotal;

                    return (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{mode}</td>
                        <td>{item?.job_token}</td>
                        <td>{item?.customer_details?.name || "-"}</td>
                        <td>{moment(item.created_at).format("DD-MM-YYYY")}</td>
                        <td>{item?.shipment_details?.origin 
                            ? item?.shipment_details?.origin_country
                            ? item.shipment_details?.origin +", "+ item.shipment_details?.origin_country
                            : item.shipment_details?.origin
                            : "-"
                        }</td>
                        <td>{item?.shipment_details?.destination 
                            ? item?.shipment_details?.destination_country
                            ? item.shipment_details?.destination +", "+ item.shipment_details?.destination_country
                            : item.shipment_details?.destination
                            : "-"
                        }</td>
                        {/* <td>{item?.shipment_details?.origin}</td>
                        <td>{item?.shipment_details?.destination}</td> */}
                        <td>{rev.toFixed(2)}</td>
                        <td>{cost.toFixed(2)}</td>
                        <td>{profit.toFixed(2)}</td>
                        <td>{profitPer.toFixed(2)}</td>
                      </tr>
                    );
                  }) || <tr><td colSpan={20} className='text-center'>Data Not Found</td></tr>}

                {
                  <tr>
                    <td colSpan={7}>
                      <strong>Total</strong>
                    </td>
                    <td>{revTotal.toFixed(2)}</td>
                    <td>{costTotal.toFixed(2)}</td>
                    <td>{profitTotal.toFixed(2)}</td>
                    <td colSpan={2}></td>
                  </tr>
                }
              </tbody>}
            </Table>
          </Row>
        </Card.Body>
      </Card>
    );
  }
}

export { Shipment };
